import { defineStore } from "pinia";
import { useCustomerStore } from "@/stores/customers";
// https://vueuse.org/core/uselocalstorage/
import { useLocalStorage } from "@vueuse/core";
import type { RemovableRef } from "@vueuse/shared";
import { useSettingsStore } from "@/stores/settings";
import { useArticoliStore } from "@/stores/articoli";
import { isNilOrEmpty } from "@/utils";

export type RootStore = {
  LOADING: number;
  VECCDAGE: RemovableRef<string>;
  AUTH_TOKEN: RemovableRef<string>;
};

//const ls = <T>(id: string, defaultValue: T): Ref<T> =>  useLocalStorage(id, defaultValue);
const ls = useLocalStorage;

export const useRootStore = defineStore({
  id: "rootStore",
  state: (): RootStore => ({
    LOADING: 0,
    VECCDAGE: ls<string>("isales/rootStore/VECCDAGE", ""),

    AUTH_TOKEN: ls<string>("isales/rootStore/AUTH_TOKEN", ""),
  }),
  getters: {
    LOADING_get: (state): boolean => state.LOADING > 0,
    IS_LOADING: (state): boolean => state.LOADING > 0,
    AUTH_TOKEN_get(state): string | undefined {
      return state.AUTH_TOKEN;
    },
    isAuthenticated(state): boolean {
      return !isNilOrEmpty(state.AUTH_TOKEN);
    },
  },
  actions: {
    LOADING_set(value: boolean): void {
      if (value) {
        this.LOADING += 1;
      } else if (this.LOADING > 0) {
        this.LOADING -= 1;
      }
    },
    AUTH_TOKEN_set(token: string, veccdage: string) {
      this.AUTH_TOKEN = token;
      this.VECCDAGE = veccdage;
    },

    AUTH_TOKEN_unset() {
      this.AUTH_TOKEN = "";
      this.VECCDAGE = "";
    },

    async load() {
      const customersStore = useCustomerStore();
      await customersStore.CUSTOMERS_loads();
    },
    async Login(veccdage: string, vecmobilepsw: string) {
      const settingsStore = useSettingsStore();
      const soapClient = settingsStore.wsClient;
      const response = await soapClient.Login({
        sVeccdage: veccdage,
        sVecmobilepsw: vecmobilepsw,
      });
      if (response?.Success) {
        this.AUTH_TOKEN_set(response.Data, veccdage);
        const customersStore = useCustomerStore();
        customersStore.CUSTOMER_unset();
        customersStore.CUSTOMERS_unset();
        const articoliStore = useArticoliStore();
        articoliStore.ARTICOLI_unsetAll();
      } else {
        throw response?.Message || "Errore durante il login";
      }
    },
  },
});
